import { ModalStore } from '../../state/ModalStore'
import CancelButton from '../Buttons/CancelButton'
import { Primary } from '../Buttons/Primary'

function ModalFooter({
    onConfirm,
    onCancel,
    type = 'confirm',
    confirmText = 'Confirm',
    confirmDisabled = false,
    cancelDisabled = false,
}) {
    const skimModal = ModalStore((state) => state.skim)

    const handleCancel = async () => {
        if (onCancel) await onCancel()
        skimModal()
    }

    const isConfirm = type === 'confirm'
    const alignment = isConfirm ? 'justify-between' : 'justify-end'
    const isSubmitButton = type === 'submit'

    return (
        <div
            className={`flex ${alignment} gap-3 border-t border-[#ECE6DC] px-[22px] py-4`}>
            {isConfirm && (
                <CancelButton
                    data-button-id="cancel-button"
                    disabled={cancelDisabled}
                    onCancel={handleCancel}></CancelButton>
            )}
            {isSubmitButton ? (
                <Primary
                    data-button-id="confirm-button"
                    disabled={confirmDisabled}
                    type="submit">
                    {confirmText}
                </Primary>
            ) : (
                <Primary
                    data-button-id="confirm-button"
                    disabled={confirmDisabled}
                    onClick={onConfirm}>
                    {confirmText}
                </Primary>
            )}
        </div>
    )
}

export default ModalFooter
